import { render, staticRenderFns } from "./AgreeItem.vue?vue&type=template&id=6c1a6cd5"
import script from "./AgreeItem.vue?vue&type=script&lang=js"
export * from "./AgreeItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports